// src/index.ts
import { providers, Signer } from "ethers";
import {
  connect,
  signTransaction,
  signMessage,
  initConfig,
  getConfig,
  getConnectedAddress,
  signTypedData
} from "@joyid/evm";
import {
  arrayify,
  getAddress
} from "ethers/lib.esm/utils";
var JoyIDSigner = class _JoyIDSigner extends Signer {
  constructor(provider, address, config = getConfig()) {
    super();
    this._address = address;
    this.provider = provider;
    this.joyidConfig = config;
  }
  getAddress() {
    return Promise.resolve(getAddress(this._address));
  }
  signTransaction(tx) {
    return signTransaction(tx, this._address, this.joyidConfig);
  }
  connect(provider) {
    return new _JoyIDSigner(provider, this._address, this.joyidConfig);
  }
  signMessage(message) {
    return signMessage(
      typeof message === "string" ? message : arrayify(message),
      this._address,
      this.joyidConfig
    );
  }
  _signTypedData(_domain, _types, _value) {
    throw new Error(
      "Ethers.js signTypedData is experimental, please use signTypedData from @joyid/ethers instead"
    );
  }
};
var JoyIDProvider = class extends providers.JsonRpcProvider {
  constructor(url, network, config) {
    super(url, network);
    this.joyidConfig = initConfig(config);
  }
  getSigner() {
    const address = getConnectedAddress();
    if (address) {
      return new JoyIDSigner(this, address, this.joyidConfig);
    }
    throw new Error("No connected address");
  }
};
export {
  JoyIDProvider,
  JoyIDSigner,
  connect,
  getConnectedAddress,
  initConfig,
  signTypedData
};
